var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDocBlank = function SvgDocBlank(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.279 2.266A.91.91 0 0 0 13.636 2H6.363a2.728 2.728 0 0 0-2.727 2.727v14.546A2.727 2.727 0 0 0 6.363 22h10.91A2.728 2.728 0 0 0 20 19.273V8.363a.91.91 0 0 0-.266-.642l-5.455-5.455ZM6.363 3.818h6.364v4.546a.91.91 0 0 0 .909.909h4.546v10a.91.91 0 0 1-.91.909H6.364a.91.91 0 0 1-.91-.91V4.728a.91.91 0 0 1 .91-.909Zm10.533 3.637h-2.35V5.104l2.35 2.35Z"
  })));
};
export default SvgDocBlank;